import { gql } from '@apollo/client';

import { buildQueryHook } from '../../../utils/buildQueryHook';
import {
  GetWorkOrderMessageThreads,
  GetWorkOrderMessageThreadsVariables,
  GetWorkOrderMessageThreads_homework_getWorkOrderMessageThreads as MessageThread,
} from '../../athena/types/GetWorkOrderMessageThreads';
import { MessageThreadFields } from '../../fragments/homework/MessageThread';

export const GET_WORK_ORDER_MESSAGE_THREAD = gql`
  query GetWorkOrderMessageThreads($workOrderId: String!) {
    homework {
      getWorkOrderMessageThreads(input: { workOrderId: $workOrderId }) {
        messageThread {
          ...MessageThreadFields
        }
        onSiteMessageThread {
          ...MessageThreadFields
        }
        workOrderId
      }
    }
  }
  ${MessageThreadFields}
`;

export default buildQueryHook<
  GetWorkOrderMessageThreads,
  GetWorkOrderMessageThreadsVariables,
  MessageThread | undefined
>(GET_WORK_ORDER_MESSAGE_THREAD, {
  wrangler: (data) => data.homework.getWorkOrderMessageThreads || undefined,
});
